import positionsStore from './modules/postionsStore'
import departmentsStore from '@/store/PositionList/modules/departmentsStore'

export const modules = {
  positionsStore,
  departmentsStore
}



// WEBPACK FOOTER //
// ./src/store/PositionList/index.js